import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PlatformNav from '../components/platform/PlatformNav';
import Ticker from '../components/marketing/Ticker';
import WatchlistSidebar from '../components/platform/WatchlistSidebar';
import BriefView from '../components/platform/views/BriefView';
import StockDiveView from '../components/platform/views/StockDiveView';
import FloatingAIPanel from '../components/platform/FloatingAIPanel';
import { useAuth } from '../hooks/useAuth';
import { auth } from '../lib/firebase';
import { apiUrl } from '../lib/api';

export default function PlatformPage() {
  const { refreshEntitlement } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView]         = useState('brief');
  const [activeSym, setActiveSym] = useState('NVDA');

  useEffect(() => {
    if (new URLSearchParams(location.search).get('upgraded') !== '1') return;
    navigate('/platform', { replace: true });
    (async () => {
      try {
        const token = await auth.currentUser?.getIdToken();
        if (token) {
          await fetch(apiUrl('/api/billing/sync'), {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
          });
        }
      } catch { /* sync is best-effort */ }
      await refreshEntitlement();
    })();
  }, []);

  function openStock(sym) {
    setActiveSym(sym);
    setView('stock');
  }

  function openBrief() {
    setView('brief');
  }

  const aiContext = view === 'brief' ? 'brief' : activeSym;

  return (
    <div className="platform-v2">
      <PlatformNav issueLabel="Issue #104 · May 19" />
      <Ticker />
      <div className="app-body-v2">
        <div className="main-v2">
          <div className={`view${view === 'brief' ? ' active' : ''}`}>
            <BriefView onSelectStock={openStock} />
          </div>
          <div className={`view${view === 'stock' ? ' active' : ''}`}>
            <StockDiveView
              sym={activeSym}
              onBack={openBrief}
              onSelectStock={openStock}
            />
          </div>
        </div>
        <WatchlistSidebar
          view={view}
          activeSym={activeSym}
          onSelectBrief={openBrief}
          onSelectStock={openStock}
        />
      </div>
      <FloatingAIPanel context={aiContext} />
    </div>
  );
}
